import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Bodys from '@/components/Bodys'
import Sham from '@/components/Shampoo'
import Bath from '@/components/Bath'
import Story from '@/components/Story'
import Contact from '@/components/Contact'
import Detail from '@/components/Detail'

import myFooter from '@/common/my-footer'
import myHeader from '@/common/my-header'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    },
    {
      path: '/Bodys',
      name: 'Bodys',
      component: Bodys
    },{
      path: '/Sham',
      name: 'Sham',
      component: Sham
    },{
      path: '/Bath',
      name: 'Bath',
      component: Bath
    },
    {
      path: '/Story',
      name: 'Story',
      component: Story
    },
    {
      path: '/Contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/Detail',
      name: 'Detail',
      component: Detail
    }
  ]



})
Vue.component('myFooter', myFooter);
Vue.component('myHeader', myHeader)



// WEBPACK FOOTER //
// ./src/router/index.js